import _taggedTemplateLiteral from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  mutation($dealerIds: [Int!]!,$schoolId: Int!) {\n    updateSchoolDealers(\n      dealerIds: $dealerIds\n      schoolId:$schoolId\n    ) {\n      id\n      address\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  mutation($input: EditSchoolInput!,$schoolId: Int!) {\n    updateSchool(\n      input: $input\n      schoolId:$schoolId\n    ) {\n      id\n      name\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  mutation($input: NewSchoolInput!) {\n    createSchool(\n      input: $input\n    ) {\n      id\n      name\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from 'graphql-tag';
export var createSchool = gql(_templateObject());
export var updateSchool = gql(_templateObject2());
export var updateSchoolDealers = gql(_templateObject3());